<template>
    <div class="staff">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>商品管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>品牌管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <div class="panel">
                    <span :key="'top'+idx" v-for="(img, idx) in topList" class="imgPanel">
                        <img class="brand" :src="'/api'+img.logoUrl" v-if="img" @click="() => handleEdit('top', idx+1)"/>
                        <span class="add" v-else @click="() => handleEdit('top', idx+1)">添加</span>
                    </span>
                </div>
                <el-skeleton />
                <div class="panel">
                    <span :key="'middle'+idx" v-for="(img, idx) in middleList" class="imgPanel">
                        <img class="brand" :src="'/api'+img.logoUrl" v-if="img" @click="() => handleEdit('middle', idx+1)"/>
                        <span class="add" v-else @click="() => handleEdit('middle', idx+1)">添加</span>
                    </span>
                </div>
                <div class="panel">
                    <span :key="'down'+idx" v-for="(img, idx) in bottomList" class="imgPanel">
                        <img class="brand" :src="'/api'+img.logoUrl" v-if="img" @click="() => handleEdit('down', idx+1)"/>
                        <span class="add" v-else @click="() => handleEdit('down', idx+1)">添加</span>
                    </span>
                </div>
            </el-card>
        </main>
        <el-dialog title="选择品牌" :visible.sync="editDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="120px">
                <el-form-item label="品牌名称(中文)" prop="id">
                    <el-autocomplete
                        v-model="editForm.id"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入内容"
                        @select="handleSelect"
                    ></el-autocomplete>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            topList: [],
            middleList: [],
            bottomList: [],
            editDialogVisible: false,
            editForm: {
                id: '',
                location: '',
                sort: '',
                item: null,
            },
            rules: {
                id: [
                    { required: true, message: '请选择品牌', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        handleEdit(location, sort) {
            this.editForm = {
                location,
                sort,
                item: null,
            };
            this.editDialogVisible = true;
        },
        querySearchAsync(queryString, cb) {
            if(queryString) {
                this.$axios.post("/admin/product/brand/list",{
                    nameCh: queryString,
                    status: '1',
                }).then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        cb(resp.data.map(it => { return {...it, value: it.nameCh + "(" + it.nameEn + ")"} }));
                    }
                }).catch(function() {
                });
            }
            // this.timeout = setTimeout(() => {
            // cb(results);
            // }, 3000 * Math.random());
        },
        handleSelect(item) {
            this.editForm.item = item;
        },
        onSubmit() {
            let that = this;
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    this.editForm.item.location = this.editForm.location;
                    this.editForm.item.sort = this.editForm.sort;
                    this.$axios.post("/admin/product/brand/setBanner", {
                        id: this.editForm.item.id,
                        sort: this.editForm.item.sort,
                        location: this.editForm.item.location,
                    }).then(function(response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {
                            that.$notify({
                                title: '成功',
                                message: '数据保存成功',
                                type: 'success'
                            });
                            that.editDialogVisible = false;
                            that.onSearch();
                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    }).catch(function() {
                    });
                }
            });
        },
        onSearch() {
            let that = this;
            this.$axios.post("/admin/product/brand/list",{
                location: 'top',
                status: '1',
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    let arr = [];
                    for(let i=1; i<7; i++) {
                        for(let j=0; j<resp.data.length; j++) {
                            if(resp.data[j].sort == i + "") {
                                arr.push(resp.data[j]);
                                break;
                            }
                        }
                        if(arr.length < i) {
                            arr.push(null);
                        }
                    }
                    that.topList = arr;
                }
            }).catch(function() {
            });
            this.$axios.post("/admin/product/brand/list",{
                location: 'middle',
                status: '1',
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    let arr = [];
                    for(let i=1; i<7; i++) {
                        for(let j=0; j<resp.data.length; j++) {
                            if(resp.data[j].sort == i + "") {
                                arr.push(resp.data[j]);
                                break;
                            }
                        }
                        if(arr.length < i) {
                            arr.push(null);
                        }
                    }
                    that.middleList = arr;
                }
            }).catch(function() {
            });
            this.$axios.post("/admin/product/brand/list",{
                location: 'down',
                status: '1',
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    let arr = [];
                    for(let i=1; i<7; i++) {
                        for(let j=0; j<resp.data.length; j++) {
                            if(resp.data[j].sort == i + "") {
                                arr.push(resp.data[j]);
                                break;
                            }
                        }
                        if(arr.length < i) {
                            arr.push(null);
                        }
                    }
                    that.bottomList = arr;
                }
            }).catch(function() {
            });
        },
    },
    created() {
        this.onSearch();
    }
}
</script>
<style scoped>
.panel {
    margin: 10px 0;
    padding: 10px;
    border: 1px dashed #ddd;
    display: flex;
    justify-content: space-around;
}
.brand {
    width: 174px;
    height: 60px;
    margin-right: 10px;
}
.imgPanel {
    cursor: pointer;
}
.add {
    width: 174px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    display: inline-block;
    border: 1px dashed #ccc;
}
</style>
